import axios from "axios";
import { getSession } from "next-auth/react";
import { ContentType } from "@/utils/enum";

const axiosInstance = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": ContentType.JSON,
    "Cache-Control": "no-store, max-age=0, must-revalidate, no-cache",
  },
});

// Function to retrieve the token
const getAuthToken = async () => {
  const session: any = await getSession(); // Get session asynchronously
  // console.log("🚀 ~ getAuthToken ~ session:", session)
  return localStorage.getItem("token") || session?.access_token;
};

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getAuthToken();
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => {
    if ([200, 201].includes(response.status)) {
      return response.data;
    }
  },
  (error) => {
    if ([401, 403].includes(error?.response?.status)) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
